<template>
  <a-row id="user-row" :gutter='16'>
    <a-col class="gutter-row" :span="6">
        <div class="gutter-box" style="background-color: #64b0f2">
            <div class="title">我的客户</div>
            <div class="content" @click="goagency(1)">
                <span class="num">{{topData.deptNum}}</span>
                <span class="cite">家</span>
            </div>
            <div class="mark">今日新入驻{{topData.newsDeptNum}}家客户</div>
        </div>
    </a-col>
    <a-col class="gutter-row" :span="6">
        <div class="gutter-box" style="background-color: #f1b53d">
            <div class="title">证书数</div>
            <div class="content" @click="goagency(2)">
                <span class="num">{{topData.certNum}}</span>
                <span class="cite">份</span>
            </div>
            <div class="mark">今日新增{{topData.newsCertNum}}份证书</div>
        </div>
    </a-col>
    <a-col class="gutter-row" :span="6">
        <div class="gutter-box" style="background-color: #3db9dc">
            <div class="title">无证报告</div>
            <div class="content" @click="goagency(3)">
                <span class="num">{{topData.reportNum}}</span>
                <span class="cite">份</span>
            </div>
            <div class="mark">今日新增{{topData.newsReportNum}}份报告</div>
        </div>
    </a-col>
    <a-col class="gutter-row" :sm="12" :md="12" :lg="6" :xl="6">
        <div class="gutter-box" style="background-color: #5cd580">
            <div class="title">关键件</div>
            <div class="content" @click="goagency(4)">
                <span class="num">{{topData.keyCertNum}}</span>
                <span class="cite">份</span>
            </div>
            <div class="mark">今日新增{{topData.newKeyCertNum}}份</div>
        </div>
    </a-col>
    <!-- <a-col class="gutter-row" :span="6">
        <div class="gutter-box" style="background-color: #ff5d48">
            <div class="title">即将到期证书</div>
            <div class="content">
                <span class="num">{{topData.soonExpireNum}}</span>
                <span class="cite">份</span>
            </div>
            <div class="mark">已过期证书{{topData.expireNum}}份</div>
        </div>
    </a-col> -->
  </a-row>
</template>
<script>
export default {
  props:{
    topData:Object
  },
  data() {
    return {
      basicData:[]
    };
  },
   mounted() {
    let userMsg = this.$store.state.user.user;
    this.roles = userMsg.roles;
  },
  methods: {
    goagency(type){
      let userMsg = this.$store.state.user.user;
      let roles = userMsg.roles;
      if(type== 1 && roles.includes('USERDEPT_SELECT')){
        this.$router.push('/user/client')
      } else if(type==2 && roles.includes('CERTIFICATE_SELECT')){
        this.$router.push('/product/manage')
      } else if(type==3 && roles.includes('REPORT_SELECT')){
        this.$router.push('/product/report')
      } else if (type == 4 && roles.includes('KEYPIECECERTIFICATE_SELECT')) {
        this.$router.push('/product/keyPartCertificate')
      }
    }
  },
  watch: {
    topData(value){
      this.basicData = value
    } 
  },
};
</script>

<style lang="less" scoped>
#user-row {
  overflow: hidden;
  .gutter-box {
    padding: 5px 10px;
    // border: 1px solid #eee;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,.1);
    border-radius: 8px;
    .title{
        font-size: 14px;
        color: #fff
    }
    .content{
        min-height: 80px;
        color: #fff;
        text-align: center;
        vertical-align: center;
        border-bottom: 1px;
        border-bottom: 1px solid #fff;
        .num{
            font-size: 50px;
        }
        .cite{
            font-size: 14px;
            margin-left: 20px;
        }
    }
    .mark{
        line-height: 30px;
        color: #fff;
    }
  }
  /deep/.ant-card {
    border-radius: 0px;
    height: 200px;
    border: 0;
    .ant-col-4{
        border: 1px solid #eee;
    }
    .ant-card-body {
      height: 100%;
    }

    .info {
      line-height: 200px;
      display: flex;
      align-items: center;

      .avatar {
      }

      .username {
        font-weight: bold;
        font-size: 18px;
        color: #333;
        margin-left: 12px;
      }
    }

    .list {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;

      .item {
        height: 63%;
        padding: 3% 0;
        width: ~'calc(33.3% - 3px)';
        text-align: center;
        border-right: 2px solid #ccc;
        .item-t {
          font-size: 16px;
          padding-bottom: 6px;
        }

        .item-b {
          font-size: 18px;
          font-weight: bold;
        }
      }
      .item:last-child{
        border-right: 0;
      }
    }


  }
}
</style>
